/* Copyright (c) 2019 VMware, Inc. All rights reserved. VMware Confidential */
import { Event } from "@app/services/dispatcher/events/event";

export class RefreshEvent extends Event {
    public static ID: string = "REFRESH";
    public source: string;

    constructor(src?: string) {
        super(RefreshEvent.ID);
        this.source = src;
    }
}
